import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import SubscriptionPlanCard from './SubscriptionPlanCard';
import TrialPlanBanner from 'Components/dashboard/TrialPlanBanner';
import { useNavigate } from 'react-router-dom';
import CurrentMembershipCard from '../CurrentMembershipCard';
import MembershipSupportBanner from '../MembershipSupportBanner';
import { analyticsLog } from 'services/analytics';
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents';

const Pricing: React.FC<{ onCancelMembership?: () => void, onProceedToCheckout?: (planId: string | number, frequency: string) => void }> = ({ onCancelMembership, onProceedToCheckout }) => {
    const plansData = useSelector((state: RootState) => state.membershipState.subscription_plans.data)
    const membershipData = useSelector((state: RootState) => state.membershipState.membership.data)
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const activePlan = membershipData?.active_plan;

    const isTrialPlan = useMemo(() => {
        return !!(activePlan?.plan_frequency?.is_trial);
    }, [activePlan]);

    const isActivePaidPlan = useMemo(() => {
        return !(activePlan?.plan_frequency?.is_trial) && !activePlan?.plan?.default;
    }, [activePlan]);

    const plans = plansData?.plans ?? [];

    const trialPlans = plans.filter((plan) => plan.frequencies?.weekly?.is_trial);

    const freePlan = plansData?.free_plan ?? null;

    const featuredPlan = plans.find((plan) => plan.featured || plan.id === 7);

    const sortedPlans = useMemo(() => {
        let sorted_plans = [];
        if (freePlan) sorted_plans.push(freePlan);
        if (featuredPlan) sorted_plans.push({ ...featuredPlan, featured: true });
        if (trialPlans.length > 0) sorted_plans.push(...(trialPlans.filter((plan) => !sorted_plans.map((p) => p.id).includes(plan.id))));
        return sorted_plans;
    }, [trialPlans, freePlan, featuredPlan])


    useEffect(() => {
        analyticsLog(ANALYTICS_EVENTS.VIEW_SUBSCRIPTION_PLANS)
    }, [])


    return (
        <div className='trial-pricings'>
            <div className="subscription-plans-wrapper">
                <div className="d-flex align-items-center justify-content-center flex-column">
                    <h1 className="subscription-plans-heading">Power Up Your</h1>
                    <h1 className="subscription-plans-heading">Creator Journey</h1>
                    <span className="subscription-plans-description mt-3">Choose a subscription plan based on your needs.</span>
                </div>
                {

                    (isTrialPlan) && <div className='container mt-4'><TrialPlanBanner onAction={(planId) => onProceedToCheckout?.(planId, 'monthly')} /></div>
                }
                {
                    (isActivePaidPlan) && <div className='container mt-4'><CurrentMembershipCard onCancelMembership={onCancelMembership} onProceedToCheckout={onProceedToCheckout} /></div>
                }
                <div className="container py-5">
                    <div className="row g-4 justify-content-center">
                        {
                            sortedPlans.map((plan) => {
                                return (
                                    <div className="col-md-4">
                                        <SubscriptionPlanCard onProceedToCheckout={onProceedToCheckout} onCancelMembership={onCancelMembership} plan={plan} frequency='monthly' isActive={activePlan?.membership_plan_id === plan.id} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="pb-5">
                    <MembershipSupportBanner />
                </div>
            </div>

        </div>
    )
}

export default Pricing